import auth from '@/services/auth'
import store from '@/store'
import {NavigationGuard} from 'vue-router'

const authGuard: NavigationGuard = async (to, from, next) => {

  if (!Object.keys(store.state.user.user).length) {
    // await store.dispatch('user/loadUser')
  }
  next()
  if (to.name === 'wikiPage' && auth.isAuthenticated() === null) {
    sessionStorage.setItem('wikiPage', to.params.id);
  }
  if (to.name === 'login') {
    if (auth.isAuthenticated()) {
      next({path: '/'})
    } else {
      next()
    }
  } else if (auth.isAuthenticated()) {
    if (to.meta && to.meta.access) {
      if (store.state.user.user.checkRole(to.meta.access)) {
        next()
      } else {
        next({name: 'accessDenied'})
      }
    } else {
      next()
    }
  } else {
    next({path: '/login'})
    auth.setPathTo(to.path)
  }
}
export default authGuard